import { FormattedMessage } from "react-intl";

import {
    SignupBackgroundLayout,
    TwcOverlayTemplate
} from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { TeamworkCollectionLogo } from "@/components/signup/utils";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { Heading } from "../../components";
import { SwitchYourSiteMessage } from "../components";

export const CrossflowEligibleUser = () => {
    const twcSignupOverlayEnrolled = checkFeatureFlagGate(
        featureFlags.cfind5480TwcSignupOverlay
    );

    let content = (
        <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
            <Heading>
                <FormattedMessage
                    id="signup.teamworkCollection.uplift.heading"
                    defaultMessage="Switch your site to Teamwork Collection"
                />
            </Heading>
            <SiteActivation CrossflowEligibleUser={<SwitchYourSiteMessage />} />
        </SignupBackgroundLayout>
    );

    if (twcSignupOverlayEnrolled) {
        content = (
            <TwcOverlayTemplate size="sm">
                <Heading>
                    <FormattedMessage
                        id="signup.teamworkCollection.uplift.heading"
                        defaultMessage="Switch your site to Teamwork Collection"
                    />
                </Heading>
                <SiteActivation
                    CrossflowEligibleUser={<SwitchYourSiteMessage />}
                />
            </TwcOverlayTemplate>
        );
    }

    return content;
};
